export default {
  getStockItemAlternative: (state) => state.stockItemAlternative,
};
